export enum SecondaryTrackRendererType {
	CIRCLE = 'circle',
	DIAMOND = 'diamond',
	TRIANGLE = 'triangle',
	SCORECARD = 'scorecard',
	EMOTICON = 'emoticon',
}
